import { updateQueryParameters } from './updateQueryParameters';

/**
 * Ensures that there is query parameter by provided name and value in browser URL
 */
export const ensureQueryParameter = (name: string, value: string) => {
  const queryParams = new URLSearchParams(window.location.search);

  // There is no need to update or add new parameter so skipping
  if (queryParams.has(name) && queryParams.get(name) === value) {
    return;
  }

  queryParams.set(name, value);

  updateQueryParameters(queryParams);
};
